import type { ModuleId } from "@gosaas/modules";
import { redirect } from "@tanstack/react-router";
import {
	isDocsSurfaceEnabled,
	isKnowledgeBaseSurfaceEnabled,
	isModuleEnabled,
	isPublicApiSurfaceEnabled,
} from "@/lib/modules";

/** Redirect when a module is off (used in route `beforeLoad`). */
export function redirectIfModuleDisabled(
	id: ModuleId,
	to: "/dashboard" | "/" = "/dashboard",
): void {
	if (id === "public_api") {
		if (!isPublicApiSurfaceEnabled()) {
			throw redirect({ to });
		}
		return;
	}
	if (id === "docs") {
		if (!isDocsSurfaceEnabled()) {
			throw redirect({ to });
		}
		return;
	}
	if (id === "knowledge_base") {
		if (!isKnowledgeBaseSurfaceEnabled()) {
			throw redirect({ to });
		}
		return;
	}
	if (!isModuleEnabled(id)) {
		throw redirect({ to });
	}
}
